module.exports = __webpack_public_path__ + "ma.svg?a0d63aedd7aaf5fd59caf0d56a3d5fdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ma.svg
// module id = 1063
// module chunks = 27